import React, { useEffect } from 'react';
import { WebinarNav } from '../components/webinar/WebinarNav';
import { WebinarHero } from '../components/webinar/WebinarHero';
import { WebinarLearn } from '../components/webinar/WebinarLearn';
import { WebinarDemo } from '../components/webinar/WebinarDemo';
import { WebinarProgram } from '../components/webinar/WebinarProgram';
import { WebinarRegister } from '../components/webinar/WebinarRegister';
import { WebinarFooter } from '../components/webinar/WebinarFooter';
import { trackEvent } from '../utils/analytics';

/** Client webinar registration page — bilingual; the session shown follows the active language. */
export function WebinarCommunications() {
  useEffect(() => {
    trackEvent('Page Viewed', {
      page: 'Webinar — Communications ATNA'
    });
  }, []);
  return <div className="w-full min-h-screen bg-[#070A1C]" data-id="element-9018" data-mp="3gq62dsk6yazf">
      <WebinarNav data-id="element-9019" data-mp="3gpmm0ga6vuni" />
      <main data-id="element-9020" data-mp="3gs8qu85p3w21">
        <WebinarHero data-id="element-9021" data-mp="3krho3mzy2c2c" />
        <WebinarLearn data-id="element-9022" data-mp="3kqq293w5fsp9" />
        <WebinarDemo data-id="element-9023" data-mp="3kq6l3pebp8ca" />
        <WebinarProgram data-id="element-9024" data-mp="3ktkmaub93bi5" />
        <WebinarRegister data-id="element-9025" data-mp="28nhzood8elfu" />
      </main>
      <WebinarFooter data-id="element-9026" data-mp="28mghlzxssyom" />
    </div>;
}